import axios from 'axios'

axios.defaults.timeout = 5000;                        //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';        //配置请求头
// axios.defaults.baseURL = 'http://proxy.jiankanghao.net:50070/api/v1/';   //配置接口地址
//axios.defaults.baseURL = 'http://127.0.0.1:9000';  
axios.defaults.baseURL = 'http://proxy.jiankanghao.net:50231';  
export default axios